import React, { FC, ReactElement } from "react";
import styles from "./ScreenLoader.module.css";
import { Spinner } from "@cloudscape-design/components";

const ScreenLoader: FC = (): ReactElement | null => {
  return (
    <div className={styles.loaderContainer} data-testid="loader">
      <Spinner size="large" />
      <h1>Loading, please wait....</h1>
    </div>
  );
};

export default ScreenLoader;
